<template>
  <section>
    <div v-if="showCountryGrid && !emptyResults" data-testid="all-destinations-view" class="grid">
      <AllDestinationsCard
        v-for="({ name, cities, image }, idx) in countriesData"
        :data-testid="`${name}-country-card`"
        :key="name"
        :name="name"
        :numCities="cities ? cities.length : 0"
        :label="labelCities(cities ? cities.length : 0)"
        :image="image"
        @openFiltersGrid="handleShowHotDestinationsGrid(idx)"
      />
    </div>
    <div v-if="showCityGrid && !emptyResults">
      <HotDestinationsGrid
        :cities="citiesData"
        :header="isHeader"
        @go-back="handleCloseHotDestinationsGrid"
        :name="hotDestinationsGridTitle"
        activeTab='allDestinations'
      />
    </div>

    <div v-if="emptyResults">
      <ClearFilters @clear-filters="handleClearFilters" />
    </div>
  </section>
</template>

<script>
import AllDestinationsCard from './AllDestinationsCard.vue'
import HotDestinationsGrid from './HotDestinationsGrid.vue'
import ClearFilters from './ClearFilters.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapMutations } = createNamespacedHelpers('offersDestinations')
export default {
  name: 'AllDestionations',
  components: {
    AllDestinationsCard,
    HotDestinationsGrid,
    ClearFilters
  },
  data() {
    return {
      showHotDestinationsGrid: false,
      hotDestinationsCitiesGrid: [],
      hotDestinationsTitleGrid: '',
      selectedIndex: 0,
      isHeader: true
    }
  },
  methods: {
    ...mapMutations(['updateFilterApply']),
    handleShowHotDestinationsGrid(idx) {
      this.selectedIndex = idx
      this.hotDestinationsCitiesGrid = this.allDestinations[idx].cities
      this.hotDestinationsTitleGrid = this.allDestinations[idx].name
      this.showHotDestinationsGrid = true
      document.getElementById('multi-offer-view').scrollIntoView()
    },
    handleCloseHotDestinationsGrid() {
      this.showHotDestinationsGrid = false
      const filterLocation = document.querySelector('#OffersLocationFilterButton input').value
      if (filterLocation) {
        document.querySelector('#clear-location-filter').click()
      }
    },
    labelCities(citiesLength) {
      return citiesLength > 1
        ? this.translate('offDealsRevampCities')
        : this.translate('offDealsRevampCity')
    },
    handleClearFilters() {
      this.updateFilterApply({ type: '', code: '' })
    },
    getCountryNameOfCity(cityCode) {
      const regEx = /[^-]*$/
      const countryCode = cityCode.match(regEx)[0]
      return this.allDestinations.find(country => country.code.toLowerCase() === countryCode.toLowerCase())
    },
    getCitiesSameCountryFilteredDestination() {
      const [{ code }] = this.filteredDestinations
      const country = this.getCountryNameOfCity(code)
      return country.cities.filter((city) => city.code.toLowerCase() !== code.toLowerCase())
    },
    getHeadNameFilteredDestination() {
      if (this.isFilterCountryApply) {
        return this.filteredDestinations[0].name
      } else if (this.isFilterCityApply) {
        const [{ code }] = this.filteredDestinations
        const country = this.getCountryNameOfCity(code)
        return country.name
      }
    }
  },
  watch: {
    allDestinations(newValue) {
      this.hotDestinationsCitiesGrid = newValue[this.selectedIndex].cities
    },
    selectedCode() {
      this.selectedIndex = 0
      this.hotDestinationsCitiesGrid = []
      this.hotDestinationsTitleGrid = ''
      this.showHotDestinationsGrid = false
    }
  },
  computed: {
    ...mapGetters(['allDestinations', 'filteredDestinations', 'selectedCode', 'hotDestinations']),
    countriesData() {
      return this.isFilterCountryApply ? this.filteredDestinations : this.allDestinations
    },
    citiesData() {
      if (this.isFilterCityApply) {
        const citiesSameCountry = this.getCitiesSameCountryFilteredDestination()
        return [...this.filteredDestinations, ...citiesSameCountry]
      }
      if (this.isFilterCountryApply) {
        return this.filteredDestinations[0].cities
      }
      return this.hotDestinationsCitiesGrid
    },
    isFilterCityApply() {
      return this.isFilterApply && this.filteredDestinations[0].type === 'city'
    },
    isFilterCountryApply() {
      return this.isFilterApply && this.filteredDestinations[0].type === 'country'
    },
    isFilterApply() {
      return this.filteredDestinations.length > 0
    },
    showCountryGrid() {
      return (
        ((!this.isFilterApply && !this.showHotDestinationsGrid) || this.isFilterCountryApply) &&
        !(this.isFilterCountryApply && this.showHotDestinationsGrid)
      )
    },
    showCityGrid() {
      return (
        (!this.isFilterApply && this.showHotDestinationsGrid) ||
        this.isFilterCityApply ||
        (this.isFilterCountryApply && this.showHotDestinationsGrid)
      )
    },
    hotDestinationsGridTitle() {
      return this.isFilterApply ? this.getHeadNameFilteredDestination() : this.hotDestinationsTitleGrid
    },
    emptyResults() {
      return this.filteredDestinations.length === 0 && this.selectedCode
    }
  }
}
</script>

<style scoped lang="scss">
.grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1.25rem;
}
</style>
